import Narratives from './container';

export default Narratives;



// WEBPACK FOOTER //
// ./src/routes/Narratives/index.js